import React, { useEffect } from "react";
import { fetchPosts } from "src/actions/community/postsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import ListVertical from "src/componets/ListVertical";
import { PostInterface, selectSilentIds, selectSilentCount } from "src/store/community/postsSlice";
import { EntityId } from "@reduxjs/toolkit";
import OptionalLink from "src/componets/OptionalLink";
import communityUrls from "src/configs/community/communityUrls";
import Loading from "src/componets/Loading";

interface propsInterface {
  app_id: number | undefined;
  target: string;
  loading?: boolean;
}

const _PreviewList = ({ app_id, target, loading } : propsInterface) => {
  const dispatch = useAppDispatch();
  const ids = useAppSelector(state => app_id ? selectSilentIds(state, app_id) : []);
  const count = useAppSelector(state => app_id ? selectSilentCount(state, app_id) : 0);
  const posts = useAppSelector(state => state.community.posts.entities);

  const renderPost = (id: EntityId) => {
    const post: PostInterface | undefined = posts ? posts[id] : undefined;

    if (!post) {
      return null;
    }

    return (
      <ListVertical.Item
        key={post.id}
        image={post.thumbnail_url}
      >
        {post.title}
      </ListVertical.Item>
    )
  }

  useEffect(() => {
    const params = { app_id, limit: 10 };
    if (!app_id || !target || loading) {
      return;
    }

    dispatch(fetchPosts({ params, target, silentId: app_id }));
  }, [app_id, target, loading, dispatch]);

  return (
    <>
      <h6 className="v-content-label o-sm">{target.toUpperCase()} { count }</h6>
      <Loading loading={loading} />

      <ListVertical>
        { ids && posts && ids.map(renderPost) }
      </ListVertical>

      {
        app_id &&
          <OptionalLink link={communityUrls.app(app_id).contentPath()}>
            View All
          </OptionalLink>
      }
    </>
  );
}

export default _PreviewList;
